import React from "react"
import { AppBar, Toolbar, Typography, Box } from "@mui/material"

import logo from "../../resources/images/precipartLogoSquare.png"
import  { AppBarStyles, ApplicationNameStyles, LogoStyles, NavigationStyles } from "./styles/NavigationStyles"

/* Component that represents the header display on interface. */
function Navigation() {

    return (
        <Box sx={NavigationStyles}>
            <AppBar position="fixed" sx={AppBarStyles}>
                <Toolbar>
                    {/* Precipart logo */}
                    <Box
                        component="img"
                        alt="Precipart Logo"
                        src={logo}
                        sx={LogoStyles}
                    />

                    {/* Application title */}
                    <Typography variant="h6" sx={ApplicationNameStyles} noWrap>
                        Conference Room Tech Support
                    </Typography>
                </Toolbar>
            </AppBar>
        </Box>
    )
}

export default Navigation
